// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphAccordion.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphAccordion.tsx");
  import.meta.hot.lastModified = "1732036225884.9565";
}
// REMIX HMR END

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import htmlParser from "../helpers/htmlParser";
import Heading from "../Heading";
function itemIsText(item) {
  return "text" in item && "titleOptional" in item && item.titleOptional;
}
export default function ParagraphAccordion({
  items,
  title
}) {
  return <article className="w-full scroll-mt-16" id={title}>
      <Heading tag="h2" className="text-center">
        {title}
      </Heading>
      <Accordion type="multiple" className="w-full" defaultValue={[itemIsText(items[0]) ? items[0].titleOptional : ""]}>
        {items.map(item => {
        if (itemIsText(item)) {
          const components = htmlParser({
            html: item.text.processed || ""
          });
          return <AccordionItem key={item.titleOptional} value={item.titleOptional}>
                <AccordionTrigger>{item.titleOptional}</AccordionTrigger>
                <AccordionContent>
                  <div className="wysiwyg py-5">
                    <div>{components}</div>
                  </div>
                </AccordionContent>
              </AccordionItem>;
        }
        return null;
      })}
      </Accordion>
    </article>;
}
_c = ParagraphAccordion;
var _c;
$RefreshReg$(_c, "ParagraphAccordion");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;